import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { ILearnActionRepository } from '../../repositories/interfaces/iLearnActionRepository';
import {
    IContentLikeDislikePayload,
    IGetContentRatingResponse,
    IGetContentRatingSearchParams,
} from '../../../entity/interface/iLearnAction';

export interface IGetContentRatingUseCase {
    execute(
        apiKey: string,
        params: IGetContentRatingSearchParams,
        identityToken: string
    ): Promise<IGetContentRatingResponse['data']>;
}

export class GetContentRatingUseCase implements IGetContentRatingUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get getContentRatingRepository(): ILearnActionRepository {
        return container.resolve<ILearnActionRepository>(DI.REPOSITORIES.ILearnActionRepository);
    }
    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        apiKey: string,
        paylod: IContentLikeDislikePayload,
        identityToken: string
    ): Promise<IGetContentRatingResponse['data']> {
        const response = await this.getContentRatingRepository.getContentRating(apiKey, paylod, identityToken);
        return response.data;
    }
}
